import { IconType } from "./IconType";
import classNames from "classnames";
import { CSSProperties } from "react";

export const Icon = ({
  type,
  className,
  style,
  filled = false
}: {
  type: IconType;
  className?: string;
  style?: CSSProperties;
  filled?: boolean;
}) => {
  return (
    <span
      className={classNames("material-symbols-rounded", className)}
      style={{ fontVariationSettings: `'FILL' ${filled ? 1 : 0}`, ...style }}
    >
      {type}
    </span>
  );
};
